import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import i18n from '@/i18n'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      titleKey: 'bottomNav.首页'
    }
  },
  {
    path: '/investment',
    name: 'Investment',
    redirect: '/',
    meta: {
      titleKey: 'bottomNav.投资',
      hidden: true
    }
  },
  {
    path: '/computing',
    name: 'Computing',
    component: () => import('../views/Computing.vue'),
    meta: {
      titleKey: 'bottomNav.算力申请'
    }
  },
  {
    path: '/translation-test',
    name: 'TranslationTest',
    component: () => import('../views/TranslationTest.vue'),
    meta: {
      titleKey: 'translationTest.pageTitle'
    }
  },
  {
    path: '/computing/applications',
    name: 'ComputingApplications',
    component: () => import('../views/ComputingApplications.vue'),
    meta: {
      titleKey: 'computing.算力申请记录'
    }
  },
  {
    path: '/computing/unstake',
    name: 'UnstakeApplications',
    component: () => import('../views/UnstakeApplications.vue'),
    meta: {
      titleKey: 'computing.申请赎回'
    }
  },
  {
    path: '/computing/application/:id',
    name: 'ComputingApplicationDetail',
    component: () => import('../views/ComputingApplicationDetail.vue'),
    meta: {
      titleKey: 'computing.算力申请详情'
    }
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import('../views/Assets.vue'),
    meta: {
      titleKey: 'bottomNav.资产'
    }
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: () => import('../views/Deposit.vue'),
    meta: {
      titleKey: 'recharge.充值',
      hideBottomNav: true,
      hideHeader: true
    }
  },
  {
    path: '/manual-deposit',
    name: 'ManualDeposit',
    component: () => import('../views/ManualDeposit.vue'),
    meta: {
      titleKey: 'recharge.充值',
      hideBottomNav: true,
      hideHeader: true
    }
  },
  {
    path: '/flash-swap',
    name: 'FlashSwap',
    component: () => import('../views/FlashSwap.vue'),
    meta: {
      titleKey: 'assets.闪兑',
      hideBottomNav: true,
      hideHeader: true
    }
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue'),
    meta: {
      titleKey: 'recharge.充值',
      hideBottomNav: true
    }
  },
  {
    path: '/recharge-history',
    name: 'RechargeHistory',
    component: () => import('../views/RechargeHistory.vue'),
    meta: {
      titleKey: 'recharge.充值记录',
      hideBottomNav: true,
      hideHeader: true
    }
  },
  {
    path: '/recharge-detail/:orderNumber',
    name: 'RechargeDetail',
    component: () => import('../views/RechargeDetail.vue'),
    meta: {
      titleKey: 'rechargeDetail.充值详情',
      hideBottomNav: true
    }
  },
  {
    path: '/airdrop-rewards',
    name: 'AirdropRewards',
    component: () => import('../views/AirdropRewards.vue'),
    meta: {
      titleKey: 'airdropRewards.空投奖励'
    }
  },
  {
    path: '/balance-logs',
    name: 'BalanceLogs',
    component: () => import('../views/BalanceLogs.vue'),
    meta: {
      titleKey: 'balanceLogs.账变记录',
      hideBottomNav: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      titleKey: 'about.pageTitle'
    }
  },
  {
    path: '/whitepaper',
    name: 'Whitepaper',
    component: () => import('../views/Whitepaper.vue'),
    meta: {
      titleKey: 'whitepaper.白皮书',
      hideBottomNav: true
    }
  },

  {
    path: '/robot-details/:robotId?',
    name: 'RobotDetails',
    redirect: '/',
    meta: { hidden: true }
  },
  {
    path: '/robot-investment/:id',
    name: 'RobotInvestment',
    redirect: '/',
    meta: { hidden: true }
  },
  {
    path: '/icon-test',
    name: 'IconTest',
    component: () => import('../views/IconTest.vue'),
    meta: {
      titleKey: 'iconTest.pageTitle'
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    redirect: '/',
    meta: { hidden: true }
  },
  {
    path: '/earnings',
    name: 'Earnings',
    redirect: '/',
    meta: { hidden: true }
  },
  {
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('../views/Withdrawal.vue'),
    meta: {
      titleKey: 'withdrawal.提现',
      hideBottomNav: true
    }
  },
  {
    path: '/withdrawal-history',
    name: 'WithdrawalHistory',
    component: () => import('../views/WithdrawalHistory.vue'),
    meta: {
      titleKey: 'withdrawal.提现记录',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/set-fund-password',
    name: 'SetFundPassword',
    component: () => import('../views/SetFundPassword.vue'),
    meta: {
      titleKey: 'setFundPassword.设置资金密码',
      hideBottomNav: true
    }
  },
  {
    path: '/kyc',
    name: 'Kyc',
    component: () => import('../views/Kyc.vue'),
    meta: {
      titleKey: 'kyc.身份认证',
      hideBottomNav: true
    }
  },
  {
    path: '/modify-fund-password',
    name: 'ModifyFundPassword',
    component: () => import('../views/ModifyFundPassword.vue'),
    meta: {
      titleKey: 'modifyFundPassword.修改安全密码',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/lucky-wheel',
    name: 'LuckyWheel',
    component: () => import('../views/LuckyWheel.vue'),
    meta: {
      titleKey: 'luckyWheel.幸运轮',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/apply-funds',
    name: 'ApplyFunds',
    component: () => import('../views/ApplyFunds.vue'),
    meta: {
      titleKey: 'applyFunds.申请备用金',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/loan-records',
    name: 'LoanRecords',
    component: () => import('../views/LoanRecords.vue'),
    meta: {
      titleKey: 'loanRecords.借款记录',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/loan-rules',
    name: 'LoanRules',
    component: () => import('../views/LoanRules.vue'),
    meta: {
      titleKey: 'loanRules.借款规则',
      hideHeader: true,
      hideBottomNav: true
    }
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('../views/Messages.vue'),
    meta: {
      titleKey: 'messages.title',
      hideBottomNav: true
    }
  },
  {
    path: '/messages/:id',
    name: 'MessageDetail',
    component: () => import('../views/Messages.vue'),
    meta: {
      titleKey: 'messages.title',
      hideBottomNav: true
    }
  },
  {
    path: '/credit-score',
    name: 'CreditScore',
    component: () => import('../views/CreditScore.vue'),
    meta: {
      titleKey: 'creditScore.pageTitle',
      hideBottomNav: true
    }
  },
  {
    path: '/flash-options',
    name: 'FlashOptions',
    component: () => import('../views/FlashOptions.vue'),
    meta: {
      titleKey: 'flashOptions.闪电期权',
      transparentHeader: true,
      hideHeaderActions: true,
      hideHeader: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      titleKey: 'notFound.title'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 设置页面标题的函数
const updatePageTitle = (route) => {
  if (route.meta.titleKey) {
    // 使用翻译键设置页面标题
    const translatedTitle = i18n.global.t(route.meta.titleKey)
    document.title = `${translatedTitle} - HamiltonLane`
  } else if (route.meta.title) {
    // 兼容旧的硬编码标题
    document.title = route.meta.title
  }
}

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  updatePageTitle(to)
  next()
})

// 监听语言切换，更新当前页面标题
let currentRoute = null
router.afterEach((to) => {
  currentRoute = to
})

// 导出更新标题函数，供语言切换时调用
window.updateCurrentPageTitle = () => {
  if (currentRoute) {
    updatePageTitle(currentRoute)
  }
}

export default router
